// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"dam-4"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 3H21C21 9 21 15.4651 21 21H3V3Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M15 21V11H9V21H15Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 21V11H12M15 21H21C21 15.4651 21 9 21 3H12M15 21H9M9 21V11H12M9 21H3V3H12M12 3V11","strokeWidth":"props.strokeWidth"}}]}]};

const Dam4Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'dam-4',
    ref,
    icon: element,
  },
));

Dam4Icon.displayName = 'Dam4Icon';

export default Dam4Icon;
